/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetVolunteerShiftsQueryVariables = Types.Exact<{
  shift_ids?: Types.Maybe<Array<Types.Scalars["Int"]> | Types.Scalars["Int"]>;
}>;

export type GetVolunteerShiftsQuery = {
  volunteerShifts: Array<
    Pick<Types.VolunteerShift, "shift_id"> & {
      category: Pick<Types.VolunteerCategory, "name" | "primary_only">;
    }
  >;
};

export const GetVolunteerShiftsDocument = gql`
  query GetVolunteerShifts($shift_ids: [Int!]) {
    volunteerShifts(where: { shift_id: { in: $shift_ids } }) {
      shift_id
      category {
        name
        primary_only
      }
    }
  }
`;

/**
 * __useGetVolunteerShiftsQuery__
 *
 * To run a query within a React component, call `useGetVolunteerShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolunteerShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolunteerShiftsQuery({
 *   variables: {
 *      shift_ids: // value for 'shift_ids'
 *   },
 * });
 */
export function useGetVolunteerShiftsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetVolunteerShiftsQuery,
    GetVolunteerShiftsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetVolunteerShiftsQuery,
    GetVolunteerShiftsQueryVariables
  >(GetVolunteerShiftsDocument, baseOptions);
}
export function useGetVolunteerShiftsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetVolunteerShiftsQuery,
    GetVolunteerShiftsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetVolunteerShiftsQuery,
    GetVolunteerShiftsQueryVariables
  >(GetVolunteerShiftsDocument, baseOptions);
}
export type GetVolunteerShiftsQueryHookResult = ReturnType<
  typeof useGetVolunteerShiftsQuery
>;
export type GetVolunteerShiftsLazyQueryHookResult = ReturnType<
  typeof useGetVolunteerShiftsLazyQuery
>;
export type GetVolunteerShiftsQueryResult = ApolloReactCommon.QueryResult<
  GetVolunteerShiftsQuery,
  GetVolunteerShiftsQueryVariables
>;
